import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Admin pages
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';

// Candidate pages
import { CandidateLogin } from './pages/candidate/CandidateLogin';
import { CandidateDashboard } from './pages/candidate/CandidateDashboard';
import { InterviewRoom } from './pages/candidate/InterviewRoom';

function App() {
  return (
    <>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Root redirect */}
          <Route path="/" element={<Navigate to="/interview-portal" replace />} />
          
          {/* Admin routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Candidate routes */}
          <Route path="/interview-portal" element={<CandidateLogin />} />
          <Route path="/interview-portal/dashboard" element={<CandidateDashboard />} />
          <Route path="/interview-portal/:interviewId" element={<InterviewRoom />} />
          
          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
